import React from "react";

const CounterText = (props) => (
	<div className="counter-text">
		Counter Value : {props.count}
	</div>
);

export default CounterText;